// extracted by mini-css-extract-plugin
export var conversationListItem = "_y5-2";
export var fullBleedList = "_y5-3";
export var messageText = "_y5-1";
export var previewText = "_y5-0";